<template>
  <div
    :style="{ zIndex: zIndex }"
    class="mg-dailog-mask"
    @click="clickModal"
    v-show="value"
    :class="[isFull ? 'full-modal' : '']"
  >
    <div class="mg-dailog-content" :class="{ [`mg-${position}-dialog`]: true }" @click.stop>
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

enum DialogPosition {
  center = 'center',
  left = 'left',
  right = 'right',
  top = 'top',
  bottom = 'bottom'
}
export default defineComponent({
  name: 'MgDialog',
  model: {
    event: 'close',
    prop: 'value'
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    isFull: {
      type: Boolean,
      default: false
    },
    modalClose: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: DialogPosition.center
    },
    zIndex: {
      type: Number,
      default: 2000
    }
  },
  methods: {
    close(this: any) {
      this.$emit('close', false)
    },
    clickModal(this: any) {
      if (this.modalClose) {
        this.$emit('close', false, 'modal')
        this.close()
      }
    }
  }
})
</script>
<style lang="scss" scoped>
.mg-dailog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
}
.center,
.mg-dailog-content {
  position: absolute;
  top: 144px;
  left: 50%;
  transform: translate(-50%, 0);
  border-radius: 12px;
  overflow: hidden;
}
.mg-bottom-dialog {
  top: auto;
  left: 0;
  right: 0;
  bottom: 0;
  transform: none;
}
.full-modal {
  .mg-dailog-content {
    border-radius: 8px 8px 0px 0px;
    bottom: 0;
    position: absolute;
    width: 100%;
  }

  .mg-dailog-content {
    height: calc(100vh - 72px);
  }
}
</style>
